/** Resolve stored font-family tokens to CSS font-family stacks. */
export function resolveFontFamily(ff?: string): string | undefined {
  const raw = typeof ff === 'string' ? ff.trim() : '';
  if (!raw) return undefined;

  const key = raw.toLowerCase();
  if (key === 'vag' || key === 'vag-regular') {
    return '"Vag","vag-regular","vag","Kohinoor Devanagari","Noto Sans Devanagari","Mukta",sans-serif';
  }
  if (key === 'vag-bold') {
    return '"Vag-Bold","vag-bold","vag","Kohinoor Devanagari","Noto Sans Devanagari","Mukta",sans-serif';
  }
  if (key === 'serif') {
    return 'Georgia, "Times New Roman", serif';
  }
  if (key === 'sans-serif' || key === 'sans') {
    return 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
  }
  if (key === 'monospace') {
    return 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace';
  }
  if (key === 'kohinoor devanagari') {
    return '"Kohinoor Devanagari","Noto Sans Devanagari","Mukta",sans-serif';
  }
  if (key === 'noto sans devanagari') {
    return '"Noto Sans Devanagari","Mukta",sans-serif';
  }
  if (key === 'mukta') {
    return '"Mukta","Noto Sans Devanagari",sans-serif';
  }

  return raw;
}

export function hasFontFamilyValue(value: unknown): boolean {
  return typeof value === 'string' && value.trim() !== '';
}
